import {Routes} from '@angular/router';

export const shopsaleRecommendationRoutes: Routes = [
  {
    path: 'shopsaleRecommendation',
    loadComponent: () => import('./shopsale-recommendation.component').then(m => m.ShopsaleRecommendationComponent),
    data: { title: '收银机商品推荐' },
  },
];
